export default __webpack_public_path__ + "static/media/placeholder_business03-nl-mobile.33c5613f.png";